const translations = {
    area: 'Area',
    drone: 'Drone',
    duration: 'Duration',
    noFlights: 'No Flights',
    noMoreFlights: 'No More Flights',
    pilot: 'Pilot',
    startTime: 'Start Time',
    type: 'Type'
};

export default translations;
